import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
// 3.5.2026 TS (claude) Service worker disabled — was caching stale bundles with hardcoded
// production API URL across deployments, breaking the new server smoke test. Active
// unregister() below cleans up SWs left from prior visits so existing browsers self-heal.
import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";

import './i18n';

import authReducer from "./store/reducers/auth";
import companyReducer from "./store/reducers/company";


const composeEnhances = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  auth: authReducer,
  company: companyReducer
});

const store = createStore(rootReducer, composeEnhances(applyMiddleware(thunk)));

const app = (
  <Provider store={store}>
    <App />
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => regs.forEach(r => r.unregister()));
  if (window.caches && caches.keys) {
    caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
  }
}
